var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_40356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_37_40356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24207 15.8303C11.9064 13.7978 15.0164 12.4584 16.5727 11.8109C21.0164 9.96281 21.9396 9.64156 22.5414 9.63093C22.6739 9.62906 22.9696 9.66156 23.1614 9.81718C23.3233 9.94843 23.3677 10.1259 23.3889 10.2503C23.4102 10.3753 23.4371 10.6584 23.4158 10.8803C23.1752 13.4103 22.1333 19.5497 21.6033 22.3834C21.3789 23.5828 20.9371 23.9847 20.5096 24.0241C19.5808 24.1097 18.8752 23.4097 17.9752 22.8197C16.5671 21.8972 15.7714 21.3222 14.4046 20.4216C12.8246 19.3803 13.8489 18.8084 14.7489 17.8734C14.9846 17.6284 19.0783 13.9047 19.1577 13.5672C19.1677 13.5247 19.1771 13.3672 19.0833 13.2841C18.9896 13.2009 18.8514 13.2297 18.7521 13.2522C18.6108 13.2841 16.3614 14.7709 12.0033 17.7128C11.3646 18.1516 10.7858 18.3647 10.2677 18.3541C9.69644 18.3416 8.59769 18.0309 7.78082 17.7653C6.77894 17.4397 5.98269 17.2672 6.05207 16.7141C6.08769 16.4259 6.48457 16.1316 7.24207 15.8303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_40356",
    x1: 16,
    y1: 0.24,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_40356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram1);
export default __webpack_public_path__ + "static/media/telegram1.e913c15f75253f081cdddbf0439b74b3.svg";
export { ForwardRef as ReactComponent };